





















































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { curCoreClient, CoreClient } from '@/services/CoreClient';
import { Device, Info, ApiKey } from '@/types/core';
import { DateTime } from 'luxon';

import GroupAccessEdit from '@/components/access/GroupAccessEdit.vue';
import GroupAccessEditSmall from '@/components/access/GroupAccessEditSmall.vue';
import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';


@Component({
  components: {
    Loading,
    VueError,
    SectionHeader,
    Success,
    GroupAccessEdit,
    GroupAccessEditSmall
  },
})
export default class EditApiKey extends Vue {

  @Prop({ default: {},  type: Object}) apiKey!: ApiKey;

  // our model
  info:Info = {} as Info;
  error:string = '';
  success:string = '';
  
  // our model
  dateTime = DateTime;
  
  httpBusy:boolean = false;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
  
  async mounted() {

    const reply = await this.coreClient.getInfo();
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve user info: ${reply.errorMsg}`;
    
    // we update the state
    this.info = reply.info as Info;
  }

  maskApiKey(apiKey:string):string {
    return apiKey.substring(0, 10) + "*****" + apiKey.substring(30);
  }

  groupIdListUpdate(newGroupIdList:string[]) {
    
    this.apiKey.groupIdList = newGroupIdList.concat();
  }

  get canUpdateApiKey():boolean {
    return !this.httpBusy && this.apiKey.groupIdList.length > 0;
  }

  async updateApiKey() {

    this.httpBusy = true;

    this.error = '';
    
    const reply = await this.coreClient.updateApiKey({
      apiKey: this.apiKey.apiKey,
      tps: this.apiKey.tps,
      tpd: this.apiKey.tpd,
      level: this.apiKey.level,
      status: this.apiKey.status,
      groupIdList: this.apiKey.groupIdList,
      description: this.apiKey.description || ''
    });

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `unable to update api key: ${reply.errorMsg}`;

    this.setSuccess(`api key ${this.apiKey.apiKey} updated successfully`);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
